import React from 'react'
import Loader from 'gui/components/common/Loader'

/**
* Component which renders a loader for content detail
*/
export const ContentDetailLoader = () => (
  <div className="loader-container">
    <Loader />
    <div className="loader__update-mask"/>
  </div>
)
